<template>
  <div class="bg-white border-radius shadow px-30 px-10-xs py-20 relative color-black">
    <div class="mb-20 flex items-center">
      <button class="btn btn-outline free-width px-15" v-ripple @click="$emit('back')">
        <i class="la la-arrow-left big-text mr-5"></i>
        Back
      </button>

      <div class="flex-1"></div>
    </div>

    <br />
    <h4 class="strong mb-5">Upgrade your account</h4>
    <h6>
      You are about to switch your account from
      <span class="capitalize strong">{{ oldPlan.plan_name }}</span>
      (<span class="capitalize">{{ oldPlan.billed }}</span
      >) to
      <span class="capitalize strong">{{ newPlan.plan_name }}</span>
      (<span class="capitalize">{{ newPlan.billed }}</span
      >)
    </h6>

    <br /><br />

    <div class="flex block-xs">
      <!-- Current plan -->
      <div class="align-center-xs relative div-border border-radius p-20">
        <div class="flex items-center mb-10 block-xs">
          <img :src="require(`@/assets/img/icons/box-${oldPlan.plan_name}.png`)" />
        </div>
        <h5 class="capitalize mb-5">
          <strong>{{ oldPlan.plan_name }}</strong>
          <span class="font-h6 ml-5">({{ oldPlan.billed }})</span>
        </h5>
        <br />
        <div class="flex items-center justify-center-xs">
          <div>
            <h1 class="strong mb-0">${{ oldPlan.price }}</h1>
            <h6>{{ price_description(oldPlan.billed) }}</h6>
          </div>
          <div v-if="oldPlan.plan_name == 'business'" class="align-center ml-30 div-border-left pl-30">
            <h1 class="strong mb-0">{{ oldPlan.quantity }}</h1>
            <h6>person</h6>
          </div>
        </div>
        <br />
        <div class="plan-bottom-lable font-h6 label-from bg-lightblur-darkmode">
          <span>From</span>
        </div>
      </div>

      <!-- Arrow button -->
      <div class="switch-plan-bridge my-30-xs">
        <span><i class="la la-arrow-right"></i></span>
      </div>

      <!-- New plan -->
      <div class="flex-1 align-center-xs relative div-border border-radius p-20 border-color-primary flex block-xs" style="border-width: 2px">
        <div class="" style="min-width: 200px">
          <div class="flex items-center mb-10 block-xs">
            <img :src="require(`@/assets/img/icons/box-${newPlan.plan_name}.png`)" />
          </div>
          <h5 class="capitalize mb-5">
            <strong>{{ newPlan.plan_name }}</strong>
            <!-- <span class="font-h6 ml-5">({{ newPlan.billed }})</span> -->
          </h5>
          <br />
          <div class="flex items-center block-xs">
            <div>
              <h1 class="strong mb-0">${{ the_price.total }}</h1>
              <h6>{{ price_description(newPlan.billed) }}</h6>
            </div>
          </div>
        </div>
        <div class="flex-1 flex flex-column items-center justify-center px-20">
          <div style="width: 400px" class="max-full-width">
            <h6 class="title mb-5">How many minutes of AI sales video do you need?</h6>
            <div class="range-slider-wrapper mb-20">
              <div class="slider-fixed"></div>
              <div class="slider-wrapper">
                <range-slider style="width: 100%" class="slider" :min="slider_min" :max="slider_max" step="1000" v-model="quantity"> </range-slider>
                <span class="range-label" :style="`left: ${((quantity - slider_min) / (slider_max - slider_min)) * 100}%`"
                  >{{ quantity.toLocaleString("de-DE") }} min</span
                >
              </div>
            </div>
          </div>

          <!-- Discount code -->
          <div style="width: 400px" class="max-full-width">
            <div class="flex items-center">
              <h6 class="mb-0">I have coupon <i class="la la-tag"></i></h6>
              <div class="flex-1"></div>
              <Switcher :value="show_coupon" :fat="true" @input="toggleCoupon" />
            </div>

            <div class="flex items-center mt-10 div-border border-radius-4 p-10" :class="{ hide: !show_coupon }">
              <input class="font-h6 flex-1 no-border" type="text" placeholder="DISCOUNT CODE" maxlength="30" v-model="coupon_code" @input="inputCoupon" />
              <span
                v-if="coupon_status == 'valid'"
                class="color-white color-white-darkmode bg-green border-radius px-5 sm-text ml-10 inline-flex items-center"
                style="height: 18px"
                >VALID</span
              >
              <span
                v-else-if="coupon_status == 'invalid'"
                class="color-white color-white-darkmode bg-lip border-radius px-5 sm-text ml-10 inline-flex items-center"
                style="height: 18px"
                >INVALID</span
              >
              <i v-else-if="coupon_status == 'loading'" class="la la-spinner spinning color-primary font-h5s ml-10"></i>
            </div>

            <p class="sm-text color-green align-right mt-5" v-if="the_price.discount != ''">
              You will get {{ the_price.discount }} of discount {{ the_price.duration_off == "forever" ? "forever" : "" }} on Weezly
            </p>
          </div>

          <div class="align-right font-body mt-10" v-if="loading_price">
            <div class="inline-flex items-center">
              <span>{{ $t("upgrade.total_cost") }}:</span>
              <i class="la la-spinner spinning color-primary ml-5 font-h5"></i>
            </div>
          </div>
          <div class="align-right font-body mt-10" v-else>
            {{ $t("upgrade.total_cost") }}: <strong>${{ the_price.price }}</strong>

            <strong v-if="the_price.discount != ''" class="color-green"> - {{ the_price.discount }} (discount)</strong>

            + <strong>VAT({{ the_price.vat }}%)</strong> =
            <strong>${{ the_price.total }}</strong>
          </div>
        </div>
        <div class="plan-bottom-lable font-h6 label-to">
          <i class="la la-check-circle mr-10 font-h5"></i>
          <span>To</span>
        </div>
      </div>
    </div>

    <br /><br />
    <h6>Note: The switching to the new plan will take effect immediately.</h6>
    <h6 v-if="newPlan.plan_name != oldPlan.plan_name" class="color-lip">
      Warning: Your current subscription of
      <span v-if="oldPlan" class="strong uppercase">{{ oldPlan.plan_type.replace("_", " ") }}</span> will be canceled!
    </h6>
    <br /><br />

    <div class="flex items-center align-center my-20 block-xs">
      <button
        class="btn btn-outline color-black strong free-height py-10 max-full-width font-h5 strong mr-20 mr-0-xs mb-20-xs"
        v-ripple
        @click="$emit('back')"
        style="width: 300px"
      >
        Cancel
      </button>

      <button
        v-if="(oldPlan.plan_type != newPlan.plan_type) | (oldPlan.quantity != quantity)"
        class="btn btn-primary strong free-height py-10 max-full-width font-h5 strong ml-20 ml-0-xs"
        :class="{ disabled: loading_price }"
        v-ripple
        @click="switchPlan"
        style="width: 300px"
      >
        <span class="">Yes, switch plan!</span>
      </button>
    </div>

    <div v-if="loading" class="absolute-inside overlay flex items-center">
      <Loading />
    </div>
  </div>
</template>

<script>
import request from "@/service";
import types from "@/constants/types";
import moment from "moment-timezone";

import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
export default {
  name: "SwitchPlan",
  components: {
    RangeSlider,
  },
  props: {
    billing: Object,
    plan_type: String,
  },
  data: function () {
    return {
      loading: false,
      quantity: 1000,
      percent: 0,

      loading_price: false,

      slider_min: 1000,
      slider_max: 50000,

      show_coupon: false,
      coupon_code: "",
      coupon_status: "",
      coupon_timeout: false,
      coupon_key: 0,

      percent_off: 0,
      amount_off: 0,
      duration_off: "",
    };
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    oldPlan() {
      return {
        ...this.billing.subscription.plan,
        plan_name: this.billing.subscription.plan.plan_type.replace("_monthly", "").replace("_yearly", ""),
        quantity: this.billing.subscription.quantity,
        price: this.billing.subscription.price,
      };
    },
    newPlan() {
      let plan = this.billing.packages.find((p) => p.plan_type == this.plan_type);
      return {
        ...plan,
        plan_name: plan.plan_type.replace("_monthly", "").replace("_yearly", ""),
      };
    },
    the_price() {
      let price = {
        price: "..",
        vat: this.percent,
        total: "..",
        discount: "",
        duration_off: this.duration_off,
      };

      if (this.newPlan.plan_price) {
        let prices = this.newPlan.plan_price.split("/");
        let price_first = parseFloat(prices[0]);
        let price_rest = parseFloat(prices[1]);
        let quantity = this.quantity;

        let min = this.newPlan.minimum_seats;
        let total_first = price_first * min;
        let total_rest = (quantity - min) * price_rest;
        let p = total_first + total_rest;

        price.price = p;

        if (this.percent_off) {
          price.discount = this.percent_off + "%";
          let discount = (p * this.percent_off) / 100;
          p = p - discount;
        } else if (this.amount_off) {
          price.discount = "$" + this.amount_off;
          p = p - this.amount_off;
        }
        if (p < 0) p = 0;

        let vat_price = (p * this.percent) / 100;
        let total = p + vat_price;

        price.total = Math.round(total * 100) / 100;
      }

      return price;
    },
  },
  async mounted() {
    if (this.plan_type == "agency_monthly") {
      this.slider_min = 20000;
      this.slider_max = 100000;
    } else {
      this.slider_min = 1000;
      this.slider_max = 50000;
    }

    let quantity = this.me.quantity_minutes;
    if (quantity < this.newPlan.minimum_seats) quantity = this.newPlan.minimum_seats;
    this.quantity = quantity;
  },
  methods: {
    async switchPlan() {
      if (this.loading | this.loading_price) return false;

      this.loading = true;

      // Step 1: Subscribe new subscription
      let subscribe = await request("POST", "stripe/changePlan", {
        plan_type: this.plan_type,
        quantity: this.quantity,
        coupon_code: this.coupon_code != "" && this.coupon_status == "valid" ? this.coupon_code : null,
      });

      // Step 2: Confirm payment
      if (subscribe) {
        if (subscribe.data.status == "exist_member_total") {
          this.$root.$emit("alert", "The number of existing members in the organization is greater than the selected number!", "error");
        } else if (subscribe.data.status == "active") {
          await this.$store.dispatch({
            type: types.getMeInfo,
          });
          this.$root.$emit("toggle-upgrade", false);
          this.$router.push("payment-success");
        } else {
          const { error } = await this.$stripe.confirmPayment({
            clientSecret: subscribe.data.clientSecret,
            confirmParams: {
              return_url: window.location.origin + "/upgrade?state=success",
            },
          });
        }
      } else {
        this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
      }
      this.loading = false;
    },
    price_description(billed) {
      if (billed == "monthly") return "per month";
      else if (billed == "yearly") return "per year";
      else return "..";
    },
    async calculate() {
      this.loading_price = true;
      const response = await request("POST", "stripe/calculateTax", {
        plan_type: this.plan_type,
        quantity: this.quantity,
      });

      if (response) {
        this.percent = response.data.percentage;
        this.loading_price = false;
      } else {
        this.$root.$emit("alert", "Could not calculate the price!", "error");
      }
    },
    toggleCoupon(value) {
      this.show_coupon = value;
      clearTimeout(this.coupon_timeout);
      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";
      this.coupon_status = "";
      this.coupon_code = "";
    },
    async inputCoupon() {
      clearTimeout(this.coupon_timeout);
      let coupon_code = this.coupon_code.trim();

      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";

      if (coupon_code == "") {
        this.coupon_status = "";
      } else {
        this.coupon_status = "loading";

        this.coupon_timeout = setTimeout(async () => {
          const response = await request("POST", "stripe/checkCouponStatus", {
            coupon_code: coupon_code,
            plan_type: this.plan_type,
          });

          if (!this.show_coupon) return false;

          if (!response && coupon_code == this.coupon_code.trim()) {
            this.coupon_status = "invalid";
          } else if (response && response.data.coupon_code == this.coupon_code.trim()) {
            let coupon_data = response.data;
            if (coupon_data.status == "valid") {
              this.coupon_status = "valid";
              this.percent_off = parseInt(coupon_data.percent_off);
              this.amount_off = parseInt(coupon_data.amount_off) / 100;
              this.duration_off = coupon_data.duration_off;
            } else {
              this.coupon_status = "invalid";
            }
          }
        }, 1000);
      }
    },
  },
};
</script>
